import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pricing-header',
  templateUrl: './pricing-header.component.html',
  styleUrls: ['./pricing-header.component.css']
})
export class PricingHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
